function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classNames from "classnames";
import componentStyles from "./two-columns-with-carousel-component.scss";
import Picture from "/components/core/picture/picture-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import ButtonLinkComponent from "/components/core/button-link/button-link-component";
import colors from "/styles/colors";
import { convertToArrayIfNeeded } from "utils/arrays";
const DEFAULT_HOTDOG_COLOR = "brand-purple";
class TwoColumnsWithCarouselComponent extends PureComponent {
    renderParagraphs(paragraphs, disableHtmlSupport) {
        if (disableHtmlSupport) {
            if (paragraphs.length == 1 && paragraphs[0]) {
                paragraphs = paragraphs[0].split("\n");
            }
            return paragraphs.map((paragraph, index)=>/*#__PURE__*/ _jsx("div", {
                    children: paragraph
                }, index));
        }
        return paragraphs.map((paragraph, index)=>/*#__PURE__*/ _jsx("div", {
                dangerouslySetInnerHTML: {
                    __html: paragraph
                }
            }, index));
    }
    renderList(bullets, disableHtmlSupport) {
        if (disableHtmlSupport) {
            return /*#__PURE__*/ _jsx("ul", {
                className: "content-list",
                children: bullets.map((bullet, index)=>/*#__PURE__*/ _jsx("li", {
                        children: bullet
                    }, index))
            });
        }
        return /*#__PURE__*/ _jsx("ul", {
            className: "content-list",
            children: bullets.map((bullet, index)=>/*#__PURE__*/ _jsx("li", {
                    dangerouslySetInnerHTML: {
                        __html: bullet
                    }
                }, index))
        });
    }
    renderButtonLink() {
        const { text, href, color, openInNewTab } = this.props.content.buttonLink;
        const target = openInNewTab ? "_blank" : undefined;
        return /*#__PURE__*/ _jsx("div", {
            className: "button-link-wrapper",
            children: /*#__PURE__*/ _jsx(ButtonLinkComponent, {
                color: color,
                href: href,
                target: target,
                children: text
            })
        });
    }
    renderAsset() {
        const { shadow, image, youtube } = this.props.asset;
        if (!image && !youtube) return undefined;
        if (image) {
            const pictureClassName = `main-image ${image.roundImage ? "round" : ""}`;
            const style = image.specificAssetStyle ? image.specificAssetStyle : {
                width: `${image.widthPercentage}%`
            };
            return /*#__PURE__*/ _jsx("div", {
                className: "asset-inner",
                style: style,
                children: /*#__PURE__*/ _jsx(Picture, _object_spread({
                    className: pictureClassName
                }, image))
            });
        } else if (youtube) {
            return /*#__PURE__*/ _jsx("div", {
                className: "asset-inner",
                style: {
                    width: `${youtube.widthPercentage}%`
                },
                children: /*#__PURE__*/ _jsx("iframe", {
                    frameBorder: 0,
                    src: youtube.src,
                    style: {
                        height: `${youtube.height}px`
                    }
                })
            });
        } else {
            return undefined;
        }
    }
    render() {
        let { assetSide, signupForm, content, hotDog, asset, hideIfNoContent } = this.props;
        let { title: contentTitle, body: contentBody, contentType, buttonLink, disableHtmlSupport } = content;
        let { shadow, image } = asset;
        const withSignupForm = signupForm && signupForm.enabled;
        contentBody = convertToArrayIfNeeded(contentBody);
        if (hideIfNoContent && (contentBody.length == 0 || !contentBody[0])) {
            return /*#__PURE__*/ _jsx("div", {});
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + (classNames("two-columns-with-carousel", {
                "asset-left": assetSide == "left",
                "with-signup": withSignupForm
            }) || ""),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "top-line",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + "content-column",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: `jsx-${componentStyles.__hash}` + " " + "content-inner",
                                children: [
                                    !disableHtmlSupport && /*#__PURE__*/ _jsx("h2", {
                                        dangerouslySetInnerHTML: {
                                            __html: contentTitle
                                        },
                                        className: `jsx-${componentStyles.__hash}` + " " + "content-title"
                                    }),
                                    disableHtmlSupport && /*#__PURE__*/ _jsx("h2", {
                                        className: `jsx-${componentStyles.__hash}` + " " + "content-title bold",
                                        children: contentTitle
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: `jsx-${componentStyles.__hash}` + " " + "content-body",
                                        children: contentType === "list" ? this.renderList(contentBody, disableHtmlSupport) : this.renderParagraphs(contentBody, disableHtmlSupport)
                                    }),
                                    buttonLink && this.renderButtonLink()
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + (classNames("asset-column", {
                                "with-shadow": shadow
                            }) || ""),
                            children: [
                                hotDog && /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        background: colors[hotDog.color] || colors[DEFAULT_HOTDOG_COLOR]
                                    },
                                    className: `jsx-${componentStyles.__hash}` + " " + "hot-dog"
                                }),
                                this.renderAsset()
                            ]
                        })
                    ]
                }),
                withSignupForm && /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "bottom-line",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: `jsx-${componentStyles.__hash}` + " " + "signup-wrapper",
                        children: [
                            signupForm.title && /*#__PURE__*/ _jsx("div", {
                                className: `jsx-${componentStyles.__hash}` + " " + "signup-title",
                                children: signupForm.title
                            }),
                            /*#__PURE__*/ _jsx(SignupFormComponent, {})
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { TwoColumnsWithCarouselComponent as default };
TwoColumnsWithCarouselComponent.defaultProps = {
    content: {},
    asset: {},
    hotDog: {
        color: DEFAULT_HOTDOG_COLOR
    },
    hideIfNoContent: false
};
